import script from "./whGOnceImg6.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg6.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg6.vue?vue&type=style&index=0&id=4dcf5b3a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcf5b3a"]])

export default __exports__